import React from 'react';

import { Trans, useTranslation } from 'react-i18next';

import { bemCssModules, getTestId } from '@utils';
import { useLocation } from '@utils/hooks';
import { LocationStateType } from '@utils/types';

import { useStore, globalActions } from '@modules';

import InfoModal from '@containers/InfoModal';

import styles from './ZHModal.scss';

const cn = bemCssModules(styles, 'ZHModal');
const ti = getTestId('ZHModal');

const ZHModal: CustomFC = ({ className }) => {
  const { t } = useTranslation();
  const [, dispatch] = useStore();

  const location = useLocation<LocationStateType['verifyCard']>();
  const { buy_token, card_id, cvv } = location?.state || {};

  const handleClose = () => dispatch(globalActions.closeZHModal());

  const handleButtonClick = () => {
    dispatch(globalActions.runZHFlow({ buy_token, card_id, cvv }));
    handleClose();
  };

  return (
    <InfoModal
      className={cn(null, [className])}
      backButton={handleClose}
      data-testid={ti()}
      title={t('zh.agreements.title')}
      description={
        <Trans i18nKey="zh.agreements.description">
          <a
            className={cn('link', ['link'])}
            href="https://zerohash.com/mercuryo"
            target="_blank"
            rel="noreferrer"
          >
            User Agreement
          </a>
          <a
            className={cn('link', ['link'])}
            href="https://zerohash.zendesk.com/hc/en-us/articles/360009900494-Privacy-Policy"
            target="_blank"
            rel="noreferrer"
          >
            Privacy Policy
          </a>
          <a
            className={cn('link', ['link'])}
            href="https://zerohash.zendesk.com/hc/en-us/articles/360008819314-State-Money-Transmitter-Disclosures"
            target="_blank"
            rel="noreferrer"
          >
            Regulatory Disclosures
          </a>
        </Trans>
      }
      buttonText={t('zh.agreements.button')}
      onClickButton={handleButtonClick}
    />
  );
};

export default ZHModal;
